import Vue from 'vue'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import { getNotReadCount } from '@/api/chat'

import { getToken } from '@/utils/auth'
import { getNotSolveFaultBack } from '@/api/appManage'
// https://penueling.com/%E6%8A%80%E8%A1%93%E7%AD%86%E8%A8%98/vue-%E5%85%A8%E7%AB%99%E4%BD%BF%E7%94%A8-websocket-%E5%82%B3%E8%BC%B8%E8%B3%87%E6%96%99/
// ws 連線站台網址
const wsUrl = process.env.VUE_APP_BASE_WS
var socket
var token = getToken()
const key = 'ItaWeb'

const emitter = new Vue({
  methods: {
    send(message) {
      console.log('傳送訊息', message)
      if (socket.readyState === 1) {
        socket.send(JSON.stringify(message))
      }
    },
    onBaseSocketOpen() {
      const vm = this
      var t = setInterval(function () {
        if (socket.readyState != 1) {
          clearInterval(t)
          return
        }
        vm.socketSendPing()
      }, 55000)
      //55000
    },
    socketSendPing() {
      const vm = this
      var payload = {
        type: 66,
      }
      socket.send(JSON.stringify(payload))
    },
    close() {
      if (socket && socket.readyState == WebSocket.OPEN) {
        socket.close()
        console.log('websocket closed.')
      }
    },
    connect() {
      const vm = this
      token = getToken()
      // alert('onSocket',token);
      if (typeof token !== 'undefined') {
        socket = new WebSocket(wsUrl, [key, token])

        socket.onopen = function (event) {
          vm.onBaseSocketOpen()
          console.log('WebSocket連線成功')
          // Message({
          //   message: "即時訊息服務器連線成功。",
          //   type: "success",
          //   duration: 2 * 1000,
          // });
          // Message({
          //   message: '即時訊息服務器連線成功。',
          //   type: 'success',
          //   duration: 5 * 1000
          // })
          emitter.$emit('open')
          if (!store.getters.account) {
            return
          }
          getNotReadCount({ account: store.getters.account }).then(response => {
            const count = parseInt(response.data)
            store.dispatch('app/setMessage', parseInt(count))
          })
        }
        socket.onmessage = function (msg) {
          console.log('收到訊息', msg)

          emitter.$emit('message', msg)
          if (!store.getters.account) {
            return
          }
          getNotReadCount({ account: store.getters.account }).then(response => {
            const count = parseInt(response.data)
            store.dispatch('app/setMessage', parseInt(count))
          })

          // console.log("接收到服務端訊息：");
        }
        socket.onerror = function (err) {
          emitter.$emit('error', err)
          console.log('WebSocket連線發生錯誤')
          // Message({
          //   message: "即時訊息服務器無法連接，請檢查您的網路。",
          //   type: "error",
          //   duration: 5 * 1000,
          // });
        }
        socket.onclose = function () {
          emitter.connect()
          console.log('WebSocket連線關閉')
          // Message({
          //   message: "即時訊息服務器已斷線，請檢查您的網路。",
          //   type: "error",
          //   duration: 2 * 1000,
          // });
        }
      }
    },
  },
})

// emitter.connect()
export default emitter
